import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { VariableClinica } from '../../../../../core/models';
import { DispositivoGenerico } from '../dispositivo-generico.model';
import { CustomValidators } from '../../../../../shared/validators/custom-validators';

/**
 *  Componente que representa al dispositivo Diuresis.
 *
 * @author aarodriguezo
 *
 * @version 01.02.0450
 * @since 01.02.0450
 */
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'tbody [diuresis]',
  templateUrl: 'diuresis.component.html',
  styleUrls: [
    '../../../biomedidas.component.css',
    '../../../views/registro-biomedida/registro-biomedida.component.css',
    './diuresis.component.css'
  ]
})
export class DiuresisComponent extends DispositivoGenerico implements OnInit {
  public diuresis: VariableClinica;

  constructor() {
    super();
  }

  public ngOnInit(): void {
    // Se busca la variable diuresis.
    this.diuresis = this.variablesClinicas.find((v) => v.alias === 'DIURESIS');

    if (this.diuresis) {
      this.forma.addControl(
        'diuresis',
        new FormControl('', [
          Validators.required,
          Validators.pattern(this.getPatronFormato(this.diuresis.formato)),
          CustomValidators.porRango(this.diuresis.min, this.diuresis.max)
        ])
      );
    }
  }

  public getData(): VariableClinica[] {
    const result: VariableClinica[] = [];
    if (this.diuresis) {
      const diuresis = this.forma.value.diuresis.replace(',', '.');

      if (Number.isNaN(Number(diuresis))) {
        return [];
      }

      this.diuresis.valor = diuresis;
      result.push(this.diuresis);
    }

    return result;
  }
}
